import DataTableIniter from '../../components/dataTablesIniter';

namespace('IO.Views.PuppetProfiles', function (exports) {
  'use strict';

  var Index = DataTableIniter.extend({
    dom: {
      DATATABLES: '.io-table',
      DELETE_ACTION_CONTAINER: '#delete-action-container',
      DELETE_ACTION: '#delete-action',
      CHECKED_POLICY: '.row-checkbox:checked',
    },

    opts: {
      filter: true,
      title: 'Click to edit',
      serverSide: true,
      aoColumnDefs: [
        {
          aTargets: [0],
          mRender: function (data, type, full) {
            if (full[3] > 0) {
              return '';
            }
            // Zurb Foundation custom form plugin requires form.custom as a DOM for custom checkboxes
            return (
              '<form class="custom">' +
              '<input type="checkbox" name="audits[]"  data-name="' +
              full[2] +
              '" class="row-checkbox row' +
              data +
              '-checkbox" value="' +
              data +
              '" />' +
              '</form>'
            );
          },
        },
      ],
    },

    events: function () {
      var events = {};

      events['click ' + this.dom.DELETE_ACTION] = '_deleteProfiles';
      return events;
    },

    render: function () {
      var rawTables = this.$el.find(this.dom.DATATABLES),
        i;

      this.dataTables = [];

      for (i = rawTables.length - 1; i >= 0; i--) {
        this._setupDatatable($(rawTables[i]));
      }

      for (i = this.dataTables.length - 1; i >= 0; i--) {
        this.listenTo(
          this.dataTables[i],
          'dataTables:row-selected',
          this._handleActions,
        );
      }
    },

    _aoColumnDefs: function () {
      return [
        {
          aTargets: [0],
          mRender: function (data, type, full) {
            if (full[3] > 0) {
              return '';
            }
            // Zurb Foundation custom form plugin requires form.custom as a DOM for custom checkboxes
            return (
              '<form class="custom">' +
              '<input type="checkbox" name="audits[]"  data-name="' +
              full[2] +
              '" class="row-checkbox row' +
              data +
              '-checkbox" value="' +
              data +
              '" />' +
              '</form>'
            );
          },
        },
      ];
    },

    _handleActions: function (elements) {
      if (elements.length === 0) {
        this.$(this.dom.DELETE_ACTION_CONTAINER).addClass('hidden');
      } else {
        this.$(this.dom.DELETE_ACTION_CONTAINER).removeClass('hidden');
      }
    },

    _deleteProfiles: function (event) {
      var selectedCheckboxes, confirmationModal, confirmMessage, ids, deleteUrl;

      event.preventDefault();

      selectedCheckboxes = this.$(this.dom.CHECKED_POLICY);
      if (selectedCheckboxes.length === 0) {
        return;
      }

      deleteUrl = this.$(this.dom.DELETE_ACTION).prop('href');

      confirmMessage =
        'You are about to delete ' +
        selectedCheckboxes.length +
        ' Puppet Profile';
      if (selectedCheckboxes.length > 1) {
        confirmMessage += 's';
      }
      confirmMessage += '. Are you sure?';

      confirmationModal = new IO.Views.ConfirmationModal({
        el: '#confirmation-modal',
        closable: false,
      });

      confirmationModal.show(confirmMessage, function (answer) {
        confirmationModal.removeListener();
        if (!answer) {
          return;
        }

        ids = _.map(selectedCheckboxes, function (checkbox) {
          return checkbox.value;
        });

        $.ajax({
          type: 'DELETE',
          url: deleteUrl,
          data: { 'puppet_profiles[]': ids },
          headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          },
        }).done(function () {
          Turbolinks.visit(location.href);
        });
      });
      return false;
    },
  });

  exports.Index = Index;
});
